import React from "react";
import { Input, Icon, NumericInput } from "@abb/abb-common-ux-react";
import { ITestPlanInstrument } from "../../models/testplan/TestplanInstrument";
import { IInstrumentPartition, ITestPlanDirection } from "../../models/testplan/InstrumentPartition";
import { ABB_CHECK_MARK, ABB_CLOSE, ABB_TRASH } from "../../utilities/IconConstants";
import { TestplanInstrumentOperations } from "../../models/testplan/TestplanInstrumentOperations";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";

interface IProps {
    instrument: ITestPlanInstrument;
    partition: IInstrumentPartition;
    onDelete: (instrument: ITestPlanInstrument, partition: IInstrumentPartition) => void;
    onSave: (instrument: ITestPlanInstrument, partition: IInstrumentPartition, partitionNameError: boolean) => void;
    onCancel: (instrument: ITestPlanInstrument, partition: IInstrumentPartition) => void;
    showError: (message: string) => void;
    countValidate: (value: string | number, direction: any, partition: any, index: number) => void;
}

interface IState {
    partition: IInstrumentPartition;
    partitionNameError: boolean;
}

export default class MeasuredEditablePartition extends React.Component<IProps, IState> {
    private _previousState: string;

    constructor(props: IProps) {
        super(props);
        this.state = {
            partition: this.props.partition,
            partitionNameError: false
        };

        this._previousState = JSON.stringify(this.props.partition);
    }

    public render() {
        return (
            <Translation>
                {
                    t =>
                        <div className="stepwizard-step">
                            <a href="#step-1" className="position-bar" />
                            <div className="position-header position-edit position-edit-color">
                                <Input dataType="text"
                                    type="normal"
                                    disabled={false}
                                    className="px-3 disable-input mt-2 input-text-center text-ellipsis page-layout"
                                    value={this.state.partition.name}
                                    onValueChange={this.setName} />
                            </div>
                            <div className="position-content position-edit position-edit-content-color">
                                <div className="mb-2">
                                    <label className="position-font">{t(CONSTANTS.POSITION_WIDTH)}: </label>
                                    <Input dataType="number"
                                        type="normal"
                                        disabled={this.props.instrument.isFixedPosition ? true : false}
                                        className="px-3 disable-input input-text-center"
                                        value={String(this.state.partition.positionWidth)}
                                        onValueChange={(value: string) => this.setPositionWidth(value, this.props.instrument, this.state.partition)} />
                                </div>
                                <hr className="hr-line position-content-line position-edit-color" />
                                {this.state.partition.directions.map((data: ITestPlanDirection, index) =>
                                    <React.Fragment key={index}>
                                        <div className="px-3 my-2">
                                            <div>
                                                <span className="col-6 no-padding text-ellipsis position-font"
                                                    style={{ float: 'left', marginTop: 6 }}
                                                >{data.name} {t(CONSTANTS.LABEL_COUNT)}:</span>
                                                <span>
                                                    <NumericInput
                                                        type="normal"
                                                        disabled={false}
                                                        disableEdit={false}
                                                        className="position-font disable-input input-text-left w-25"
                                                        value={data.count}
                                                        min={0}
                                                        max={99}
                                                        step={1}
                                                        onChange={(value: number) => this.setDirectionCount(value, index)}
                                                        onLostFocus={() => this.props.onSave(this.props.instrument, this.state.partition, this.state.partitionNameError)}
                                                    />
                                                </span>
                                            </div>
                                        </div>
                                        <hr className="hr-line position-content-line position-edit-color"  />
                                    </React.Fragment>
                                )}
                                <div className="position-button mt-1 ml-1 p-1">
                                    <span className="position-button-color cursor"
                                        onClick={() => this.props.onSave(this.props.instrument, this.state.partition, this.state.partitionNameError)}>
                                        <Icon name={ABB_CHECK_MARK} color="#3366ff" />
                                        {t(CONSTANTS.BUTTON_SAVE)}
                                    </span>
                                    <span className="position-button-color cursor"
                                        onClick={() => this.props.onCancel(this.props.instrument, JSON.parse(this._previousState))}>
                                        <Icon name={ABB_CLOSE} color="#3366ff" />
                                        {t(CONSTANTS.BUTTON_CANCEL)}
                                    </span>
                                    <span className="cursor" onClick={() => this.props.onDelete(this.props.instrument, this.state.partition)}>
                                        <Icon name={ABB_TRASH} color="red" />
                                    </span>
                                </div>

                            </div>
                        </div>
                }
            </Translation>
        );
    }

    setDirectionCount(value: string | number, index: number): void {
        if(value === undefined) value = "0";
        let directions = [...this.state.partition.directions];
        let direction = { ...directions[index] };
        direction.count = Number(value);
        directions[index] = direction;
        this.setState({
            partition: {
                ...this.state.partition,
                directions
            }
        }, () => {
            this.props.countValidate(value, direction, this.state.partition, index)
        });
    }

    private setPositionWidth = (value: string, instrument: ITestPlanInstrument, partition: IInstrumentPartition) => {
        const lengthVal = value.split(".").join("")
        if (TestplanInstrumentOperations.validatePartition(instrument, partition, Number(lengthVal))) {
            this.setState({
                partition: {
                    ...this.state.partition,
                    positionWidth: Number(lengthVal)
                }
            });
        } else {
            this.props.showError("Invalid position width.");
        }
    }

    private setName = (value: string) => {
        var rgFile = CONSTANTS.COMMONREGEXP;
        if (value.trim() && !rgFile.test(value)) {
            this.setState({
                partition: {
                    ...this.state.partition,
                    name: value
                },
                partitionNameError: false
            });
        } else {
            this.setState({
                partition: {
                    ...this.state.partition,
                    name: value
                },
                partitionNameError: true
            });
        }
    }
}